import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function SpecialitiesFilter({ values, placeholder }) {
  const [allSkills, setAllSkills] = useState([]);
  const { state, setSpecialities } = useAllFilterBaseContext();
  const { specialities } = state;

  useEffect(() => {
    setAllSkills(values);
  }, [values]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    const updatedSkills = [...specialities, newLanguage];
    setSpecialities(updatedSkills);
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = specialities.filter(
      (language) => language.id !== id,
    );
    setSpecialities(updatedLanguages);
  };
  return (
    <div>
      <ReactSelect
        options={
          Array.isArray(allSkills) &&
          allSkills
            .filter((lang) => {
              return (
                Array.isArray(specialities) &&
                !specialities.some(
                  (selectedLang) => selectedLang.id == lang.id,
                )
              );
            })
            .map((lang) => ({ value: lang.id, label: lang.title }))
        }
        placeholder={`Search ${placeholder || "Here"}`}
        isClearable={true}
        value={[]}
        onChange={(options) => {
          if (options) {
            handleLanguageChange(options);
          }
        }}
      />

      <div className="add-skills">
        {Array.isArray(specialities) &&
          specialities.map((skills, index) => (
            <div key={index}>
              <p onClick={() => handleDeleteLanguage(skills.id)}>
                {skills.title} <span>x</span>
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
